import { usePopoverState, Popover, PopoverAction, PopoverGroup } from 'components/Popover';
import { useUploadAreaContext } from 'components/UploadArea/UploadAreaProvider/context';
import { SubtitleStyles, hoverTextStyles, popoverContainerStyles, popoverTextStyles } from './Subtitle.styles';

const supportedFormatText: { [key in CF.UI.UISupportedUploadTypes]: string } = {
  text: 'Supported text formats: TXT',
  image: 'Supported image formats: JPEG, PNG, TIFF, BMP and WEBP',
  video: 'Supported video formats: AVI, MP4, WMV, MOV, GIF and 3GPP',
  'image,video': 'Supported image formats: JPEG, PNG, TIFF, BMP, WEBP, AVI, MP4, WMV, MOV, GIF and 3GPP',
  audio: 'Supported audio formats: MP3',
};

export const Subtitle = (): JSX.Element => {
  const { mediaType } = useUploadAreaContext();
  const fileSizePopover = usePopoverState({ placement: 'bottom-start' });
  const supportedFormatPopover = usePopoverState({ placement: 'bottom-start' });

  return (
    <div data-testid="upload-area-subtitle">
      <div className={SubtitleStyles}>
        View&nbsp;
        <PopoverAction
          className={hoverTextStyles}
          popover={fileSizePopover}
          onMouseEnter={() => fileSizePopover.setVisible(true)}
          onMouseLeave={() => fileSizePopover.setVisible(false)}
        >
          file sizes
        </PopoverAction>
        &nbsp;and&nbsp;{' '}
        <PopoverAction
          className={hoverTextStyles}
          popover={supportedFormatPopover}
          onMouseEnter={() => supportedFormatPopover.setVisible(true)}
          onMouseLeave={() => supportedFormatPopover.setVisible(false)}
        >
          supported formats
        </PopoverAction>
      </div>
      <Popover
        className={popoverContainerStyles}
        popover={fileSizePopover}
        tabIndex={0}
        aria-label="file-sizes-popover"
        data-testid="file-sizes-popover"
      >
        <PopoverGroup className={popoverTextStyles}>File size limits are 100MB for video and 20MB for audio, images, and text</PopoverGroup>
      </Popover>
      <Popover
        className={popoverContainerStyles}
        popover={supportedFormatPopover}
        tabIndex={0}
        aria-label="supported-formats-popover"
        data-testid="supported-formats-popover"
      >
        <PopoverGroup className={popoverTextStyles}>{supportedFormatText[mediaType]}</PopoverGroup>
      </Popover>
    </div>
  );
};
